import { render, staticRenderFns } from "./SttDictionarySetting.vue?vue&type=template&id=6aa21dbe&scoped=true"
import script from "./SttDictionarySetting.vue?vue&type=script&lang=js"
export * from "./SttDictionarySetting.vue?vue&type=script&lang=js"
import style0 from "./SttDictionarySetting.vue?vue&type=style&index=0&id=6aa21dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa21dbe",
  null
  
)

export default component.exports